import { render, staticRenderFns } from "./FinalPanel.vue?vue&type=template&id=8e80b878&scoped=true&"
import script from "./FinalPanel.vue?vue&type=script&lang=js&"
export * from "./FinalPanel.vue?vue&type=script&lang=js&"
import style0 from "./FinalPanel.vue?vue&type=style&index=0&id=8e80b878&prod&lang=scss&"
import style1 from "./FinalPanel.vue?vue&type=style&index=1&id=8e80b878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e80b878",
  null
  
)

export default component.exports